import { VTabs, VTab, VTabsItems, VTabItem, VSimpleTable, VBtn } from 'vuetify/lib'
import Vmenu from './vmenu.vue'
import { tabsFields } from './fields'
import { getListApi, saveApi } from './services'
export default {
    data() {
        return {
            selectTab: 0,
            contract_type_list: [],
            company_list: [],
            loading_hash: {}
        }
    },
    mounted() {
        this.getTableData()
    },
    methods: {
        getTableData() {
            const selectTab = this.selectTab
            // 0 表示 合同类型
            // 1 表示 公司
            getListApi({
                model_type: selectTab === 0 ? 'contract_type' : 'company'
            }).then(res => {
                if (selectTab === 0) {
                    this.contract_type_list = res
                } else {
                    this.company_list = res
                }
            })
        },
        saveItem(data, item) {
            const selectTab = this.selectTab
            this.$set(this.loading_hash, item.id, true)
            saveApi({
                model_type: selectTab === 0 ? 'contract_type' : 'company',
                model_id: item.id,
                customer_id: data.id
            }).then(() => {
               this.$Message.success('修改成功!')
               this.getTableData()
            }).finally(() => {
                this.loading_hash[item.id] = false
            })
        }   
    },
    render() {
        const _this = this
        return <div>
          <VTabs
             v-model={_this.selectTab}
             on={{
                change:() => {
                    _this.getTableData()
                }
             }}
             >
            {tabsFields.map(item => {
               return <VTab key={item.label} >{item.label}</VTab>
            })}
          </VTabs>
          <VTabsItems v-model={_this.selectTab}>
              <VTabItem>
                  <VSimpleTable style={{
                      maxWidth: '500px'
                  }}>
                  <thead>
                        <tr>
                            <th class="text-center">
                                配置项
                            </th>
                        <th class="text-center">
                            审核人员
                        </th>
                        </tr>
                    </thead>
                    <tbody>
                        {this.contract_type_list && this.contract_type_list.map(item => {
                            return <tr
                           
                            >
                            <td class="text-center">{item.name }</td>
                            <td class="text-center">           
                                <Vmenu 
                                    item={item}
                                    loading={_this.loading_hash[item.id]}
                                    on={{
                                        change:_this.saveItem
                                    }}
                                />
                            </td>
                            </tr>
                        })}
                     
                    </tbody>
                 </VSimpleTable>
              </VTabItem>
              <VTabItem>
              <VSimpleTable style={{
                      maxWidth: '500px'
                  }}>
                  <thead>
                        <tr>
                        <th class="text-center">
                            配置项
                        </th>
                        <th class="text-center">
                            审核人员
                        </th>
                        </tr>
                    </thead>
                    <tbody>
                        {this.company_list && this.company_list.map(item => {
                            return <tr
                           
                            >
                            <td class="text-center">{item.name }</td>
                            <td class="text-center">
                                <Vmenu 
                                    item={item}
                                    loading={_this.loading_hash[item.id]}
                                    on={{
                                        change:_this.saveItem
                                    }}
                                />
                            </td>
                            </tr>
                        })}
                    </tbody>
                 </VSimpleTable>
              </VTabItem>
          </VTabsItems>
        </div>
    }
}